import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getAuth, signInWithEmailAndPassword, onAuthStateChanged } from "firebase/auth";
import { initializeApp } from "firebase/app";
import "./AdminLogin.css";

// ✅ Firebase yapılandırması
const firebaseConfig = {
  apiKey: "AIzaSyChTBDv3TekspBjhb-2f_3b9gkEiK08Xf0",
  authDomain: "ottomun-87f07.firebaseapp.com",
  databaseURL: "https://ottomun-87f07-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "ottomun-87f07",
  storageBucket: "ottomun-87f07.firebasestorage.app",
  messagingSenderId: "407610425827",
  appId: "1:407610425827:web:3a9256288c1fa7efc320d6",
  measurementId: "G-4H7M5H7C7V"
};

// 🔹 Firebase başlat
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

const AdminLogin = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  // 🔒 Eğer zaten giriş yapılmışsa, doğrudan admin paneline yönlendir
  useEffect(() => {
    const isLoggedIn = localStorage.getItem("adminLoggedIn") === "true";
    if (isLoggedIn) {
      navigate("/admin");
    }

    // Ayrıca Firebase oturum kontrolü
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        localStorage.setItem("adminLoggedIn", "true");
        navigate("/admin");
      }
    });

    return () => unsubscribe();
  }, [navigate]);

  // 🔑 Giriş işlemi
  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      await signInWithEmailAndPassword(auth, email, password);
      localStorage.setItem("adminLoggedIn", "true"); // ✅ String olarak kaydet
      navigate("/admin");
    } catch (err) {
      console.error("Firebase Auth error:", err.message);
      setError("Invalid email or password.");
    }
  };

  return (
    <div className="login-container">
      <h1>Admin Login</h1>
      <form onSubmit={handleLogin} className="login-form">
        <label>Email</label>
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />

        <label>Password</label>
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />

        {error && <p className="error-msg">{error}</p>}

        <button type="submit" className="login-btn">
          Login
        </button>
      </form>
    </div>
  );
};

export default AdminLogin;
